import {
    CLOUDLOGINPAGE_SEARCH_TEMPLATES_REQUEST,
    CLOUDLOGINPAGE_SEARCH_TEMPLATES_RESULT,
    CLOUDLOGINPAGE_SAVE_TEMPLATE_REQUEST,
    CLOUDLOGINPAGE_SAVE_TEMPLATE_RESULT,
    CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_REQUEST,
    CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_RESULT,
    CLOUDLOGINPAGE_GET_LOGIN_PAGE_REQUEST,
    CLOUDLOGINPAGE_GET_LOGIN_PAGE_RESULT,
    CLOUDLOGINPAGE_CONFIRM_TO_SAVE_OPEN_MODAL,
    CLOUDLOGINPAGE_CONFIRM_TO_SAVE,
    CLOUDLOGINPAGE_CONFIRM_TEMPLATE_OPEN_MODAL,
    CLOUDLOGINPAGE_CONFIRM_TEMPLATE,
} from "Redux/actionTypes";

export const cloudLoginPageSearchTemplatesRequest = () => ({
    type: CLOUDLOGINPAGE_SEARCH_TEMPLATES_REQUEST
})

export const cloudLoginPageSearchTemplatesResult = () => ({
    type: CLOUDLOGINPAGE_SEARCH_TEMPLATES_RESULT
})

export const cloudLoginPageSaveTemplateRequest = () => ({
    type: CLOUDLOGINPAGE_SAVE_TEMPLATE_REQUEST
})

export const cloudLoginPageSaveTemplateResult = () => ({
    type: CLOUDLOGINPAGE_SAVE_TEMPLATE_RESULT
})

export const cloudLoginPageSaveLoginPageRequest = (fileKey, preview, content, language) => ({
    type: CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_REQUEST,
    payload: { fileKey, preview, content, language }
})

export const cloudLoginPageSaveLoginPageResult = (data, error) => ({
    type: CLOUDLOGINPAGE_SAVE_LOGIN_PAGE_RESULT,
    payload: { data, error }
})

export const cloudLoginPageGetTemplateRequest = (data) => ({
    type: CLOUDLOGINPAGE_GET_LOGIN_PAGE_REQUEST,
    payload: data,
})

export const cloudLoginPageGetTemplateResult = (result) => ({
    type: CLOUDLOGINPAGE_GET_LOGIN_PAGE_RESULT,
    payload: result,
})

export const cloudLoginPageConfirmToSaveOpenModal = (open) => ({
    type: CLOUDLOGINPAGE_CONFIRM_TO_SAVE_OPEN_MODAL,
    payload: open,
})

export const cloudLoginPageConfirmToSave = (data) => ({
    type: CLOUDLOGINPAGE_CONFIRM_TO_SAVE,
    payload: data,
})

export const cloudLoginPageConfirmTemplateOpenModal = (open) => ({
    type: CLOUDLOGINPAGE_CONFIRM_TEMPLATE_OPEN_MODAL,
    payload: open,
})

export const cloudLoginPageConfirmTemplate = (data) => ({
    type: CLOUDLOGINPAGE_CONFIRM_TEMPLATE,
    payload: data,
})